import axios from 'axios';

export const postSubmitData = async (obj) => {
  //Mlab Airtable: https://v1.nocodeapi.com/multimedialab/airtable/eZQTFmpdTCFdNUNY
  //Technology Airtable: https://v1.nocodeapi.com/hdinteractive/airtable/DNjvLyqzkVXPjxxw
  const response = await axios.post('https://v1.nocodeapi.com/hdinteractive/airtable/DNjvLyqzkVXPjxxw?tableName=requests', obj, { headers: { 'Content-Type': 'application/json' } })
  return response.data;
}